// extracted by mini-css-extract-plugin
export default {"box":"Box_box__IqN7H","boxTitle":"Box_boxTitle__X-BQi","children":"Box_children__s0Kwx","missing":"Box_missing__Q37Nz","editButton":"Box_editButton__TRbgA"};